


import Model from './model.js';

export default class Address extends Model {
    urlRoot() { return '/Addresses'; }

    constraints() {
        // If the address belongs to a location that is not the primary one,
        // we only require state information
        if (this.companyLocation && !this.companyLocation.get('primary')) {
            return {
                state: {presence: {message: '^State is required'}}
            };
        }

        return { city: {
            format: {
                pattern: /^.{0,50}$/,
                message: '^A city name cannot contain more than 50 characters.'
            }
        },
        streetAddress: {
            format: {
                pattern: /^.{0,150}$/,
                message: '^A Street Address cannot contain more than 150 characters.'
            }
        },
        postcode: {
            format: {
                pattern: /^.{0,20}$/,
                message: '^A Postal Code cannot contain more than 20 characters.'
            }
        }};
    }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize(attr, {companyLocation = null} = {}) {
        this.idAttribute = 'objectId';
        this.companyLocation = companyLocation;
        return super.initialize(...arguments);
    }

    static getStatesList() {
        return [
            {code: '01', name: 'Johor'},
            {code: '02', name: 'Kedah'},
            {code: '03', name: 'Kelantan'},
            {code: '14', name: 'Kuala Lumpur'},
            {code: '15', name: 'Labuan'},
            {code: '04', name: 'Malacca'},
            {code: '05', name: 'Negeri Sembilan'},
            {code: '06', name: 'Pahang'},
            {code: '07', name: 'Penang'},
            {code: '08', name: 'Perak'},
            {code: '09', name: 'Perlis'},
            {code: '16', name: 'Putrajaya'},
            {code: '12', name: 'Sabah'},
            {code: '13', name: 'Sarawak'},
            {code: '10', name: 'Selangor'},
            {code: '11', name: 'Terengganu'}
        ];
    }

    getStateName() {
        return Address.getStateName(this.get('state'));
    }

    isBlank() {
        return (
            !this.get('line1') &&
            !this.get('city') &&
            !this.get('state') &&
            !this.get('postcode') &&
            !this.get('contactPhone')
        );
    }

    static getStateName(code) {
        const state = Address.getStatesList()
            .find(state => state.code === code);
        return state && state.name;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/address.js